<template>
    <div class="remGood" @click="handleDetail(recommendData.spuId)">
        <div class="img">
            <img :src="$viewImageNew(recommendData.spuImgUrls, 400,400)" alt="">
        </div>
        <div class="title">{{ recommendData.spuName }}</div>
        <div class="price">销售价：<span><sub>¥</sub>{{ recommendData.sellPrice }}</span></div>
        <div class="btn">查看推荐商品</div>
    </div>
</template>

<script>
export default {
    props: {
        recommendData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    methods: {
        handleDetail (id) {
            this.$emit('handleDetail', id)
        }
    }
}
</script>

<style lang="scss" scoped>
    .remGood{
        width: 344px;
        margin: 0 auto;
        padding: 48px 0;
        .img{
            width: 100%;
            height: 344px;
            position: relative;
            display: flex;
            background-color: #FAFAFA;
            img{
                display: inline-block;
                margin: 0 auto;
                background: #f2f3f5;
                object-fit: cover;
                align-self: center;
                justify-self: center;
            }
        }
        .title{
            font-size: 26px;
            color: #000000;
            margin-top: 16px;
            line-height: 36px;
            text-align: left;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
        }
        .price {
            margin-top: 8px;
            color: #666666;
            font-size: 24px;
            sub{
                font-size: 22px;
            }
            span{
                color: #FF7A45;
                font-size: 34px;
            }
        }
        .btn{
            font-size: 28px;
            color: #FF7A45;
            border: 2px solid #FF7A45;
            height: 64px;
            line-height: 64px;
            border-radius: 64px;
            margin-top: 40px;
        }
    }
</style>